import { useEffect, useState, Fragment } from "react";
import { adminApi } from "@/lib/adminApi";
import { fmtDate } from "@/pages/admin/util";
import { Loader2, ChevronDown, ChevronUp } from "lucide-react";
import IntelligencePanel from "@/components/admin/IntelligencePanel";

export default function OperatorEnquiries() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    adminApi.get("/operator-enquiries").then((r) => setItems(r.data.items)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-operators-page">
      <span className="eyebrow">B2B Pipeline</span>
      <h1 className="font-display text-[32px] lg:text-[40px] leading-[1.05] tracking-tight text-[#071A33] mt-2">Operator pilot enquiries</h1>
      <p className="text-sm text-[#475569] mt-1">Operator intelligence is auto-matched and shown inline — click <em>Intel</em> on any row.</p>

      <div className="mt-6 admin-panel overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-[#F7F4ED] text-left text-[#475569] text-xs uppercase tracking-[0.15em]">
              <th className="px-4 py-3">Company</th>
              <th className="px-4 py-3">Contact</th>
              <th className="px-4 py-3">Email</th>
              <th className="px-4 py-3">Sites</th>
              <th className="px-4 py-3">Message</th>
              <th className="px-4 py-3">Created</th>
              <th className="px-4 py-3 text-right">Intel</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={7} className="px-4 py-8 text-center text-[#475569]"><Loader2 className="animate-spin inline" size={16}/></td></tr>}
            {!loading && items.length === 0 && <tr><td colSpan={7} className="px-4 py-8 text-center text-[#475569]">No operator enquiries yet.</td></tr>}
            {items.map((o) => {
              const isOpen = openId === o.id;
              return (
                <Fragment key={o.id}>
                  <tr className="border-t border-[#E2DCD0] align-top">
                    <td className="px-4 py-3 font-medium text-[#071A33]">{o.company_name}</td>
                    <td className="px-4 py-3 text-[#475569]">{o.contact_name}</td>
                    <td className="px-4 py-3 text-[#475569]">{o.email}</td>
                    <td className="px-4 py-3 text-[#071A33]">{o.sites_count}</td>
                    <td className="px-4 py-3 text-[#475569] max-w-md whitespace-pre-wrap">{o.message || "—"}</td>
                    <td className="px-4 py-3 text-[#475569] whitespace-nowrap">{fmtDate(o.created_at, true)}</td>
                    <td className="px-4 py-3 text-right">
                      <button
                        onClick={() => setOpenId(isOpen ? null : o.id)}
                        className="text-xs px-2.5 py-1.5 border border-[#0F766E] text-[#0F766E] hover:bg-[#0F766E] hover:text-white inline-flex items-center gap-1 rounded"
                        data-testid={`op-intel-btn-${o.id}`}
                      >
                        {isOpen ? <><ChevronUp size={12}/> Hide</> : <><ChevronDown size={12}/> Intel</>}
                      </button>
                    </td>
                  </tr>
                  {isOpen && (
                    <tr className="border-t border-[#E2DCD0] bg-[#F7F4ED]/50">
                      <td colSpan={7} className="px-4 py-4">
                        <IntelligencePanel
                          companyName={o.company_name}
                          description={o.message}
                        />
                      </td>
                    </tr>
                  )}
                </Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
